import { EDITOR_SLIDER_LIMITS } from "../../../../config/newsletterEditorConfig";

export const TEXT_ALIGN_OPTIONS = [
  { value: "left", label: "Sinistra" },
  { value: "center", label: "Centro" },
  { value: "right", label: "Destra" },
];

export const VERTICAL_ALIGN_OPTIONS = [
  { value: "top", label: "Alto" },
  { value: "center", label: "Centro" },
  { value: "bottom", label: "Basso" },
];

export const LINK_TARGET_OPTIONS = [
  { value: "", label: "Nessun link" },
  { value: "https://www.wowcheprezzi.it", label: "Sito WOW Che Prezzi" },
];

export const FONT_SIZE_MAX_PX = EDITOR_SLIDER_LIMITS.fontSizePx.max;
export const FONT_SIZE_MIN_PX = EDITOR_SLIDER_LIMITS.fontSizePx.min;

export const parsePx = (value, fallback = 0) => {
  if (value === undefined || value === null || value === "") {
    return fallback;
  }
  const parsed = Number.parseInt(String(value).replace("px", "").trim(), 10);
  return Number.isFinite(parsed) ? parsed : fallback;
};

export const formatPx = (value) => `${value}px`;

export const parseFontWeight = (value, fallback = 400) => {
  const parsed = Number.parseInt(String(value), 10);
  return Number.isFinite(parsed) ? parsed : fallback;
};

export const parsePercent = (value, fallback = 100) => {
  if (value === undefined || value === null || value === "") {
    return fallback;
  }
  const str = String(value).replace("%", "").trim();
  const parsed = Number.parseInt(str, 10);
  return Number.isFinite(parsed) ? parsed : fallback;
};

export const formatPercent = (value) => `${value}%`;

export const verticalAlignToFlex = (value) => {
  if (value === "bottom") {
    return "flex-end";
  }
  if (value === "center") {
    return "center";
  }
  return "flex-start";
};

/** Maps editor vertical align to CSS table-cell vertical-align. */
export const columnVerticalAlignToCss = (contentVAlign) => {
  if (contentVAlign === "center") {
    return "middle";
  }
  if (contentVAlign === "bottom") {
    return "bottom";
  }
  return "top";
};
 